// Tiny event bus so any high-intent moment (waitlist signup, check result)
// can ask the globally-mounted FoundingMomentDialog to surface — without
// prop-drilling through the whole tree.
//
// Usage:
//   import { triggerFoundingModal } from "../lib/foundingTrigger";
//   triggerFoundingModal("check_result");
//
// The dialog still owns all gating (once-per-session, 7-day dismissal, etc.),
// so callers can fire freely; suppressed states are ignored downstream.

export const FOUNDING_TRIGGER_EVENT = "blendsafe:founding-trigger";

export function triggerFoundingModal(reason = "event") {
  try {
    window.dispatchEvent(
      new CustomEvent(FOUNDING_TRIGGER_EVENT, { detail: { reason } }),
    );
  } catch {
    /* SSR / no window — no-op */
  }
}
